import { queryOptions } from "@tanstack/react-query";

import { getPreviewPlan } from "./admin-preview";

import { getMyPlanStatus } from "./plans.functions";
import { getMyProfile } from "./profile.functions";
import { getMyAds, getMySalesSummary } from "./ads.functions";
import { getPromotionStatus, listMyPromotions } from "./promotions.functions";
import { getMyAdStats } from "./ad-stats.functions";
import { listSavedPlaces } from "./addresses.functions";
import { getInbox } from "./messages.functions";
import { getMyRole } from "./admin.functions";
import { myBidActivity } from "./auctions.functions";

/**
 * En enda plats för alla återkommande datahämtningar.
 * Samma nyckel överallt ger samma cache – ingen sida hämtar samma sak två gånger
 * och en route-loader kan alltid förladda exakt det sidan visar.
 */

const STALE = 30_000;

export const myPlanQuery = () => {
  // Administratörer kan förhandsvisa sajten som en annan nivå – då cachas den separat.
  const asPlan = getPreviewPlan();
  return queryOptions({
    queryKey: ["my-plan", asPlan],
    queryFn: () => getMyPlanStatus({ data: { asPlan } }),
    staleTime: STALE,
  });
};

export const myProfileQuery = () =>
  queryOptions({ queryKey: ["my-profile"], queryFn: () => getMyProfile({}), staleTime: STALE });

export const myAdsQuery = () =>
  queryOptions({ queryKey: ["my-ads"], queryFn: () => getMyAds({}), staleTime: STALE });

export const mySalesQuery = () =>
  queryOptions({
    queryKey: ["my-sales"],
    queryFn: () => getMySalesSummary({}),
    staleTime: STALE,
  });

export const myPromotionsQuery = () => {
  const asPlan = getPreviewPlan();
  return queryOptions({
    queryKey: ["my-promotions", asPlan],
    queryFn: () => getPromotionStatus({ data: { asPlan } }),
    staleTime: STALE,
  });
};

export const myPromotionCampaignsQuery = () =>
  queryOptions({
    queryKey: ["my-promotion-campaigns"],
    queryFn: () => listMyPromotions({}),
    staleTime: STALE,
  });

export const myAdStatsQuery = () =>
  queryOptions({ queryKey: ["my-ad-stats"], queryFn: () => getMyAdStats({}), staleTime: STALE });

export const savedPlacesQuery = () =>
  queryOptions({
    queryKey: ["saved-places"],
    queryFn: () => listSavedPlaces({}),
    staleTime: STALE,
  });

export const inboxQuery = () =>
  queryOptions({
    queryKey: ["inbox"],
    queryFn: () => getInbox({}),
    staleTime: 5_000,
    refetchInterval: 10_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });


export const myRoleQuery = () =>
  queryOptions({ queryKey: ["my-role"], queryFn: () => getMyRole({}), staleTime: 5 * 60_000 });

export const myBidsQuery = () =>
  queryOptions({
    queryKey: ["my-bids"],
    queryFn: () => myBidActivity({}),
    staleTime: 15_000,
  });
